import { I18NText } from '../shared/i18-ntext';

export class EmployeeTraining {
    siteTrainingId: number;
    name: string;

    answeredId: number;

    status: TrainingStatus;
    effectiveDate: Date;

    expireDate: Date;
    completionDate: Date;

    definition: TrainingDefinition;

    step: number;
    score: number;

    successful: boolean;
    finished: boolean;

    disabled: boolean;

    passingPercentile: number;
}

export enum TrainingStatus {
    notstarted = 'notstarted',
    expired = 'expired',
    complete = 'complete',
    incomplete = 'incomplete',
}

export class TrainingDefinition {
    videoUrl: string;

    videoWatched: boolean;

    questions: TrainingQuestion[];
}

export class TrainingQuestion {
    id: string;

    question: I18NText[];

    options: AnswerOption[];

    selectedAnswerId: string;
}

export class AnswerOption {
    id: string;
    answer: I18NText[];
}
